// Central data-testid constants used across the Thai Cottage Industries site.

export const NAV = {
    root: "site-navbar",
    logo: "navbar-logo",
    linkHome: "nav-link-home",
    linkAbout: "nav-link-about",
    linkCollections: "nav-link-collections",
    linkWhatsapp: "nav-link-whatsapp",
    mobileToggle: "nav-mobile-toggle",
    mobileMenu: "nav-mobile-menu",
};

export const HOME = {
    root: "home-page",
    hero: "home-hero",
    heroExploreBtn: "hero-explore-btn",
    heroWhatsappBtn: "hero-whatsapp-btn",
    heritageStrip: "home-heritage-strip",
    featuredCategories: "home-featured-categories",
    aboutPreview: "home-about-preview",
    signatureCollections: "home-signature-collections",
    whyChooseUs: "home-why-choose-us",
    testimonials: "home-testimonials",
    testimonialsPrev: "testimonials-prev",
    testimonialsNext: "testimonials-next",
    whatsappCta: "home-whatsapp-cta",
    whatsappCtaBtn: "home-whatsapp-cta-btn",
    emergentLink: "emergent-link",
};

export const ABOUT = {
    root: "about-page",
    hero: "about-hero",
    story: "about-story",
    mission: "about-mission",
    values: "about-values",
    expertise: "about-expertise",
    process: "about-process",
    cta: "about-cta",
    ctaVisit: "about-cta-visit",
    ctaWhatsapp: "about-cta-whatsapp",
};

export const COLLECTIONS = {
    root: "collections-page",
    hero: "collections-hero",
    category: (slug) => `category-${slug}`,
    enquireBtn: (slug) => `category-enquire-${slug}`,
    privateCta: "collections-private-cta",
    privateCtaBtn: "collections-private-cta-btn",
};

export const FOOTER = {
    root: "site-footer",
    linkHome: "footer-link-home",
    linkAbout: "footer-link-about",
    linkCollections: "footer-link-collections",
    linkWhatsapp: "footer-link-whatsapp",
    email: "footer-email",
    phone: "footer-phone",
    address: "footer-address",
};

export const FORM = {
    trigger: "whatsapp-form-trigger",
    dialog: "whatsapp-form-dialog",
    fullName: "whatsapp-form-fullname",
    country: "whatsapp-form-country",
    email: "whatsapp-form-email",
    phone: "whatsapp-form-phone",
    interestedIn: "whatsapp-form-interested",
    interestedInTrigger: "whatsapp-form-interested-trigger",
    budget: "whatsapp-form-budget",
    message: "whatsapp-form-message",
    submit: "whatsapp-form-submit",
    close: "whatsapp-form-close",
};

export const LOADER = {
    root: "site-loader",
};
